import React from "react";
import { cn } from "@/lib/utils";
import TextCardListed, {
  TextCardListedProps,
} from "@/components/ui/text-card-listed";

export interface TextCardGroupProps {
  id?: string;
  className?: string;
  heading?: string;
  description?: string;
  overrideColumns?: boolean;
  numOfColumnsLg?: number;
  numOfColumnsMd?: number;
  numOfColumnsSm?: number;
  textCardGroupClassName?: string;
  items?: TextCardListedProps[];
}

const TextCardGroup: React.FC<TextCardGroupProps> = ({
  id = "text-card-group",
  className,
  heading = "Heading",
  description = "Description",
  textCardGroupClassName = "grid gap-6 md:grid-cols-2 md:gap-x-12 md:gap-y-10 lg:grid-cols-3 lg:gap-y-12",
  items = [
    {
      title: "Card 1",
      items: ["Item 1", "Item 2", "Item 3"],
      button: {
        color: "teal",
        children: "Learn more",
      },
      href: "#",
    },
    {
      title: "Card 2",
      items: ["Item 1", "Item 2", "Item 3"],
      button: {
        color: "teal",
        children: "Learn more",
      },
      href: "#",
    },
    {
      title: "Card 3",
      items: ["Item 1", "Item 2", "Item 3"],
      button: {
        color: "teal",
        children: "Learn more",
      },
      href: "#",
      children: "Test description",
    },
  ],
  overrideColumns = false,
  numOfColumnsLg = 4,
  numOfColumnsMd = 3,
  numOfColumnsSm = 2,
}) => {
  const cards = items.map(
    (item: TextCardListedProps & { cardItems?: { text: string }[] }) => ({
      ...item,
      items: item?.cardItems?.map((cardItem) => cardItem.text),
    })
  ) as TextCardListedProps[];

  return (
    <section
      id={id}
      aria-label={id}
      className={cn(
        "mx-auto flex w-full max-w-lg flex-col gap-6 p-4 md:gap-8 md:px-6 md:py-8 lg:gap-10 lg:px-3 lg:py-10",
        className
      )}
    >
      <div className="flex flex-col gap-2 font-montserrat lg:gap-4">
        <h2 className="font-montserrat text-heading-4 text-secondary-500 md:text-heading-3 lg:text-heading-2">
          {heading}
        </h2>
        <p className="font-montserrat text-subheading-3-400 text-neutral-500 lg:text-subheading-2">
          {description}
        </p>
      </div>
      <div
        className={cn(
          textCardGroupClassName,
          "mx-auto grid gap-6 px-4 md:gap-y-10 lg:gap-y-12 lg:px-0",
          overrideColumns
            ? `grid lg:grid-cols-${numOfColumnsLg} md:grid-cols-${numOfColumnsMd} grid-cols-${numOfColumnsSm}`
            : cn(
                (cards?.length === 2 || cards?.length === 4) &&
                  "grid grid-cols-1 md:grid-cols-2 md:gap-x-12 md:gap-y-10 lg:grid-cols-2 lg:gap-y-12",
                cards?.length === 5 && "grid-cols-1 md:grid-cols-3"
              )
        )}
      >
        {items.map((textCardListedItem) => (
          <TextCardListed
            {...textCardListedItem}
            key={id + "-" + textCardListedItem.title}
            className={cn(
              "flex h-full w-full flex-col justify-between",
              textCardListedItem.className
            )}
          />
        ))}
      </div>
    </section>
  );
};

export default TextCardGroup;
